import addARIACurrent from './module/addARIACurrent';
import pcViewportFixed from './module/pcViewportFixed';
import {slideToggle} from './module/slideToggle';
import pcAddIshover from './module/pcAddIshover';
import accessibleGnavToggle from './module/accessibleGnavToggle';
import smoothScroll from './module/smoothScroll';
import selectStateAddClass from './module/selectStateAddClass';
import tab from './module/tab';
import appendSignupHeading from './module/appendSignupHeading';
import {BREAK_POINTS} from './settings';

(function () {

  window.addEventListener('DOMContentLoaded', function(e) {
		selectStateAddClass();
    addARIACurrent();
    pcViewportFixed();
    pcAddIshover();
	  smoothScroll();
		tab();

		appendSignupHeading();

		const unitEl = document.querySelectorAll('.js-slide-unit');
		[].forEach.call(unitEl, function (el) {
			const btn = el.querySelector('.js-slide-switch');
			const elTarget = el.querySelector('.js-slide-target');
			btn.addEventListener('click', function(e) {
				slideToggle(e.currentTarget, elTarget);
			});
		});

		const sToggleBtn = document.querySelector('.l-nav__s-switch');
		if(sToggleBtn) {
			sToggleBtn.addEventListener('click', function(e) {
				e.preventDefault();
				document.querySelector('.l-header__search').classList.toggle('is-show')
			})
		}

		const elements = document.querySelectorAll('.c-el-date,.c-el-select,.c-el-text');

		function addClassName(e) {
			e.classList.add('is-fill')
		}
		function remveClassName(e) {
			e.classList.remove('is-fill')
		}

		elements.forEach((el) => {
			el.addEventListener('change', (e) => {
				const target = e.currentTarget;
				const val = target.value;
				if(val) {
					addClassName(target);
				} else {
					remveClassName(target);
				}
			});

			const changeEvt = new Event("change");
			el.dispatchEvent(changeEvt);
		});

  });

  accessibleGnavToggle();
})();
